import produce from 'immer';
import { WritableDraft } from 'immer/dist/internal';
import { Actions } from './action';
import { AvcState } from './interface';
import { AvcActions, Inputs } from './enum';
import { FormType } from 'Container/App/enum';

export const initialState: AvcState = {
    loading: false,
    error: undefined,
    form: {
        type: FormType.ADDRESS,
        city: '',
        street: '',
        number: '',
        index: -1,
        touched: false,
    },
    addresses: [],
    accessSupplier: '',
};

const setForm = (draft: WritableDraft<AvcState>, index: number = 0) => {
    draft.form.touched = false;

    const address = draft.addresses[index];

    if (!address) {
        return;
    }

    draft.form.city = address.city ?? '';
    draft.form.street = address.street ?? '';
    draft.form.number = (address.housenumber ?? '') + (address.housenumberextra ?? '');
    draft.form.index = index;
};

const setInput = (draft: WritableDraft<AvcState>, name: Inputs, value: string) => {
    if (draft.form[name] === value) {
        return;
    }

    draft.form[name] = value;
    draft.form.touched = true;
    draft.form.index = -1;
};

const avcReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AvcActions.SET_LOADING:
                draft.loading = action.loading;
                break;
            case AvcActions.SET_ACCESS_SUPPLIIER:
                draft.accessSupplier = action.accessSupplier;
                break;
            case AvcActions.SET_ROLLOUT_END_MONTH:
                draft.rolloutEndMonth = action.rolloutEndMonth;
                break;
            case AvcActions.SET_ROLLOUT_STATUS:
                draft.rolloutStatus = action.rolloutStatus;
                break;
            case AvcActions.SET_AVAILABILITY_INDICATOR:
                draft.availabilityIndicator = action.availabilityIndicator;
                break;
            case AvcActions.SET_ERROR:
                draft.error = action.error;
                break;
            case AvcActions.SET_INPUT:
                setInput(draft, action.name, action.value);
                break;
            case AvcActions.SET_FORM:
                setForm(draft, action.index);
                break;
            case AvcActions.SET_ADDRESSES:
                draft.addresses = action.addresses;
                setForm(draft);
                break;
            case AvcActions.RESET_FORM:
                draft.form = { ...initialState.form };
                draft.addresses = [];
        }
    });

export default avcReducer;
